module.exports = __webpack_public_path__ + "static/media/prismax-nav.58fa0760.png";